export const INDIVIDUAL_NAME_PREFIX = 'ИП';

export const COMPANY_NAME_PREFIXES: string[] = [
    INDIVIDUAL_NAME_PREFIX,
    'ООО',
    'ОАО',
    'АО',
    'ПАО',
    'ЗАО',
    'ГБОУ',
    'СНТ',
];

export default function isCompanyName(name: string): boolean {
    if (!name) {
        return false;
    }

    const upperCaseName = name.toUpperCase();
    return COMPANY_NAME_PREFIXES.some(prefix => upperCaseName.startsWith(prefix));
}